import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 25425A4D-48BD-4139-BA72-81D0DAB54020
 * name garage-alert-variant
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage-alert-variant.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const GarageAlertVariantIcon = createSvgIcon(<><path d="M20 9V20H18V11H2V20H0V9L10 5L20 9M17 12H3V14H17V12M17 15H3V17H17V15M22 15V10H24V15H22M22 19V17H24V19H22Z" /></>, 'GarageAlertVariantIcon');
export default GarageAlertVariantIcon